module.exports = __webpack_public_path__ + "img/java_natural_ba_list.6678f709.jpg";